export default __webpack_public_path__ + "static/media/CallInboundNotification.d41e4e35.wav";